import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sofb1: FaireReviewEntity = {
  token: "review_sofb1",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "brand",
  reviewerName: "Carol",
  reviewerLocation: "Montgomery, AL",
  stars: 5,
  reviewText: "Many companies offer “sleepwear to streetwear.” Most of the times I’ve been disappointed because it looks like 100% jammies. These sets are truly compatible with going out, running errands, or even dressing them up with booties or heels. Just love this company.",
  reviewDate: "Nov 8, 2021",
  purchasedProductTokens: [
    "p_sfmywzj52b",
    "p_jjcrjr276j",
    "p_mgv9v328tw",
  ],
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
